import React, { useEffect, useState } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import moment from "moment";
import ReportPatientsTable from "./ReportPatientsTable";
import Tooltip from '@material-ui/core/Tooltip';
import ReportsPatientsExcel from '../exports/ReportsPatientsExcel';
import history from '../../../history';
import { InvoiceUtils } from '../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/InvoiceUtils';
import reciptPdf from '../../Admissions/SearchAdmissions/components/ReciptPdf';
import { formatNumber } from '../../Utils/Money';
import Spinner from 'react-bootstrap/Spinner';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AlertModal from '../../../shared/components/Modal';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const styles = theme => ({
    date: {
        margin: 10
    }
});


const ReportsPatientsFilter = ({ backToDashboard }) => {

    const [showPDF, setShowPDF] = useState(false);
    const [starterDate, setStarterDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [dataReport, setDataReport] = useState(null);
    const [dataReportAdmisions, setDataReportAdmisions] = useState([]);
    const [dataToExcel, setDataToExcel] = useState([]);
    const [dataToExcelFilter, setDataToExcelFilter] = useState(false);
    const [totalInvoiced, setTotalInvoiced] = useState(0);
    const [totalReceiptMoney, setTotalReceiptMoney] = useState(0);
    const [totalCreditEntity, setTotalCreditEntity] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [patientsAttended, setPatientsAttended] = useState(0);
    const [servicesDo, setServicesDo] = useState(0);
    const [medicineDelivered, setMedicineDelivered] = useState(0);
    const [radiopharmaciesApply, setRadiopharmaciesApply] = useState(0);

    const [third, setThird] = useState(null);
    const [thirdContract, setThirdContract] = useState(null);
    const [thirds, setThirds] = useState([]);
    const [thirdContracts, setThirdContracts] = useState([]);

    const [showAlertModal, setAlertShowModal] = useState(false);
    const [messagAlerteModal, setAlertMessageModal] = useState(null);
    const [colorAlertModal, setAlertColorModal] = useState("info");

    useEffect(() => {
        getThirds();
    }, []);

    const getThirds = async () => {
        let url = "tercero/listar";
        fetch(process.env.REACT_APP_PUBLIC_URL + url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            setThirds(data);
        }).catch((error) => {
            console.error('Error:', error);
            setThirds([]);
        });
    }

    const getThirdContracts = async (id_tercero) => {
        let dataQuery = {
            id_tercero: id_tercero
        }
        let url = "contratos/consultar";
        fetch(process.env.REACT_APP_PUBLIC_URL + url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataQuery)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.existe == true) {
                setThirdContracts(data.contenido);
                setThirdContract(null);
            }
            else {
                setThirdContracts([]);
                setThirdContract(null);
            }
        }).catch((error) => {
            console.error('Error:', error);
            setThirdContracts([]);
            setThirdContract(null);
        });
    }

    const generateReport = async () => {

        if (starterDate == null && endDate == null) {
            setAlertColorModal("danger");
            setAlertMessageModal("La Fecha Inicial y la Fecha Final son obligatorias para generar el Reporte");
            setAlertShowModal(true);
            return;
        }
        else if (starterDate == null) {
            setAlertColorModal("danger");
            setAlertMessageModal("La Fecha Inicial es obligatoria para generar el Reporte");
            setAlertShowModal(true);
            return;
        }
        else if (endDate == null) {
            setAlertColorModal("danger");
            setAlertMessageModal("La Fecha Final es obligatoria para generar el Reporte");
            setAlertShowModal(true);
            return;
        }

        setIsLoading(true);
        let fechaInicial = moment(starterDate).format('YYYY/MM/DD');
        let fechaFinal = moment(endDate).format('YYYY/MM/DD');
        let dataSend = {
            fecha_inicial: moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            fecha_final: moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            id_tercero: third,
            id_contrato: thirdContract
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reporte-pacientes/reporte-general-pacientes', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data != null && data != undefined) {
                setDataReport(data);
                setDataReportAdmisions(data.admisiones);
                setTotalInvoiced(data.subtotal);
                setTotalReceiptMoney(data.copago);
                setTotalCreditEntity(data.total_recibos);
                setServicesDo(data.servicios_realizados);
                setMedicineDelivered(data.medicamentos_entregados);
                setRadiopharmaciesApply(data.radiofarmacos_aplicados);
                setPatientsAttended(data.pacientes_atendidos);
            }
            else {
                setDataReport(null);
                setDataReportAdmisions([]);
                setTotalInvoiced(0);
                setTotalReceiptMoney(0);
                setTotalCreditEntity(0);
                setServicesDo(0);
                setMedicineDelivered(0);
                setRadiopharmaciesApply(0);
                setPatientsAttended(0);
            }
            setIsLoading(false);
        }).catch((error) => {
            console.error('Error:', error);
            setIsLoading(false);
            setDataReport(null);
            setDataReportAdmisions([]);
            setTotalInvoiced(0);
            setTotalReceiptMoney(0);
            setTotalCreditEntity(0);
            setServicesDo(0);
            setMedicineDelivered(0);
            setRadiopharmaciesApply(0);
            setPatientsAttended(0);

            setAlertColorModal("danger");
            setAlertMessageModal("Ha ocurrido un error generando el Reporte");
            setAlertShowModal(true);
        });
    }

    const generateExcel = () => {
        try {
            if(dataToExcelFilter){
                ReportsPatientsExcel.exportExcel(filteredDataExcel);
            } else {
                ReportsPatientsExcel.exportExcel(dataReportAdmisions);
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    const getAdmision = (id_admision) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ id_admision: id_admision })
            }).then(response => {
                return response.json();
            }).then(data => {
                resolve(data);
            }).catch((error) => {
                console.error('Error:', error);
                resolve({ existe: false });
            });
        });
    }

    const goToAdmision = (id_admision) => {
        getAdmision(id_admision).then((data) => {
            if (data.existe == true) {
                history.push({
                    pathname: process.env.PUBLIC_URL + '/assitencial/add-admission',
                    state: {
                        caidas: data.contenido[0].caidas,
                        dataPatient: data.contenido[0],
                        id_admision: data.contenido[0].id_admision,
                        recibo_pago: data.contenido[0].pago
                    }
                });
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const goToInvoice = async (num_fac_ter, nota_credito) => {
        try {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-por-numero', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ num_fac_ter: num_fac_ter })
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.factura != null) {
                    let factura = data.factura;
                    let InvoiceUt = new InvoiceUtils();
                    let idsReceipts = InvoiceUt.extractIdForReceipts(factura);
                    InvoiceUt.getReceiptsById(idsReceipts, factura.id_tercero, factura.num_fac_ter, nota_credito).then((res) => {
                        if (res != null) {
                            setShowPDF(true);
                            if (res.factura.recibosCaja.length > 1) {
                                InvoiceUt.generatePDFPrevisualizationInvoices(res.factura, factura.es_factura);
                            }
                            else {
                                InvoiceUt.generatePDFPrevisualization(res.factura, factura.es_factura);
                            }
                        }
                        else {
                            console.log("Error consultando la Previsualizacion de la Factura");
                        }
                    }).catch((error) => {
                        setShowPDF(false);
                        console.log(error);
                    });
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
        catch (e) {
            console.log(e);
        }
    }

    const goToCashReceipt = async (id_admision, id_admision_padre) => {
        let id_admision_query = id_admision_padre != null && id_admision_padre != undefined ? id_admision_padre : id_admision;
        getAdmision(id_admision_query).then((data) => {
            if (data.existe == true) {
                loadBilling(data.contenido[0].id_admision).then((billingData) => {
                    loadPlan(billingData, data.contenido[0]);
                });
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const loadBilling = (id_admision) => {
        return new Promise((resolve, reject) => {
            var dataBilling = { id_admision: id_admision };
            console.log(dataBilling);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataBilling)
            }).then(response => {
                return response.json();
            }).then(data => {
                resolve(data.contenido[0]);
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        })
    }

    const loadPlan = (billing, dataAdmision) => {
        var dataClose = { id_plan: billing.id_plan };
        fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataClose)
        }).then(response => {
            return response.json();
        }).then(data => {
            loadDataProfile(billing, data.contenido[0], dataAdmision);
        }).catch((e) => {
            console.log(e);
        });
    }

    const loadDataProfile = (billing, plan, dataAdmision) => {
        fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(resp => {
            if (resp.length > 0) {
                let dataReciboCaja = {
                    dataPatient: dataAdmision,
                    dataCashReceipt: billing,
                    dataPlan: plan,
                    dataProfile: resp[0],
                    state: null
                }
                infoPrintReciept(billing, plan, resp[0], dataAdmision.id_admision);
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const infoPrintReciept = async (billing, plan, profile, id_admision) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(res => {
            reciptPdf(billing, plan, profile, res);
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    const getNotaCredito = async (id_factura_t) => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factura-electronica/revisar-url-nota-credito?id_factura_t=${id_factura_t}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Error de Conexion con el Proveedor de Facturación Electronica');
            }
        }).then(data => {
            setShowPDF(true);
            document.getElementById('pdfV').src = data.url_nota;
        }).catch(err => {
            setShowPDF(false);
            console.log(err);
        });
    }

    let filteredDataExcel;

    const handleFilterValue = (value) => {
        if(value != null && value != undefined && value != ""){
            filteredDataExcel = dataReportAdmisions.filter((item) =>  item.num_documento_paciente.startsWith(value))
            setDataToExcelFilter(true);
        } else {
            setDataToExcelFilter(false);
        }
        //setDataToExcel(filteredData);
    }

    return (
        <Card>
            <CardBody>

                {
                    backToDashboard != null && backToDashboard != undefined ? <div className='top_info_buttons_hc'>
                        <div>
                            <Tooltip
                                title="Regresar al Dashboard"
                            >
                                <IconButton
                                    aria-label="upload picture"
                                    component="span"
                                    className='tooltip-top'
                                    onClick={() => {
                                        backToDashboard();
                                    }}
                                >
                                    <ArrowBackIcon style={{ color: '#153365' }} />
                                </IconButton>
                            </Tooltip>
                            <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                        </div>
                        <br/>
                    </div> : null
                }

                <Row>
                    <Col md={12}>
                        <div className="card__title">
                            <h4 className="bold-text">
                                {backToDashboard != null && backToDashboard != undefined ? "Reporte General de Pacientes" : "Filtros"}
                            </h4>
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={3}>
                        <TextField
                            label="Cliente"
                            value={third}
                            onChange={(event) => {
                                setThird(event.target.value);
                                getThirdContracts(event.target.value);
                            }}
                            select
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        >
                            <MenuItem key={0} value={null}>
                                Ninguno
                            </MenuItem>
                            {thirds.map((item, index) => {
                                return (<MenuItem key={parseInt(index) + 1} value={item.id_tercero}>
                                    {item.nombre}
                                </MenuItem>)
                            })}
                        </TextField>
                    </Col>
                    <Col md={3}>
                        <TextField
                            label="Contrato"
                            value={thirdContract}
                            onChange={(event) => {
                                setThirdContract(event.target.value);
                            }}
                            select
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        >
                            <MenuItem key={0} value={null}>
                                Ninguno
                            </MenuItem>
                            {thirdContracts.map((item, index) => {
                                return (<MenuItem key={parseInt(index) + 1} value={item.id_contrato}>
                                    {item.contrato_descripcion}
                                </MenuItem>)
                            })}
                        </TextField>
                    </Col>
                    <Col md={3}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <KeyboardDatePicker
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    value={starterDate}
                                    variant="inline"
                                    autoOk={true}
                                    onChange={(date) => {
                                        setStarterDate(date);
                                    }}
                                    label="Fecha Inicial"
                                    format="yyyy/MM/DD"
                                    animateYearScrolling
                                    className='medical-material-form__field material-form__label'
                                />
                            </ThemeProvider>
                        </MuiPickersUtilsProvider>
                        <br /><br />
                    </Col>
                    <Col md={3}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <KeyboardDatePicker
                                    style={{ minWidth: '300px', maxWidth: '100%' }}
                                    value={endDate}
                                    onChange={(date) => {
                                        setEndDate(date);
                                    }}
                                    variant="inline"
                                    autoOk={true}
                                    label="Fecha Final"
                                    format="yyyy/MM/DD"
                                    animateYearScrolling
                                    className='medical-material-form__field material-form__label'
                                />
                            </ThemeProvider>
                        </MuiPickersUtilsProvider>
                        <br /><br />
                    </Col>
                    <Col md={3}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                generateReport();
                            }}
                        >
                            Consultar
                        </Button>
                    </Col>
                </Row>
                <Row>
                    {
                        isLoading == true ? <div className="text-center">
                            <br />
                            <Spinner animation="border" variant="success" />
                        </div> : <>
                            {
                                dataReportAdmisions.length > 0 ? <>
                                    <Col md={2}>
                                        <h4><b>Pacientes Atendidos:</b> {patientsAttended}</h4>
                                    </Col>
                                    <Col md={2}>
                                        <h4><b>Servicios Realizados:</b> {servicesDo}</h4>
                                    </Col>
                                    <Col md={2}>
                                        <h4><b>RadioFarmacos Aplicados:</b> {radiopharmaciesApply}</h4>
                                    </Col>
                                    <Col md={2}>
                                        <h4><b>Total Facturado:</b> {totalInvoiced != null ? `$ ${formatNumber(totalInvoiced)}` : ""}</h4>
                                    </Col>
                                    <Col md={2}>
                                        <h4><b>Total Recibido:</b> {totalReceiptMoney != null ? `$ ${formatNumber(totalReceiptMoney)}` : ""}</h4>
                                    </Col>
                                    <Col md={2}>
                                        <h4><b>Total Crédito:</b> {totalCreditEntity != null ? `$ ${formatNumber(totalCreditEntity)}` : ""}</h4>
                                    </Col>
                                </> : null
                            }
                        </>
                    }

                </Row>
                {
                    dataReportAdmisions.length > 0 && isLoading == false ?
                        <div>
                            <ReportPatientsTable
                                reactTableData={dataReportAdmisions}
                                goToAdmision={(id_admision) => goToAdmision(id_admision)}
                                goToInvoice={(num_fac_ter, nota_credito) => { goToInvoice(num_fac_ter, nota_credito) }}
                                goToCashReceipt={(id_admision, id_admision_padre) => { goToCashReceipt(id_admision, id_admision_padre) }}
                                getNotaCredito={(id_factura_t) => { getNotaCredito(id_factura_t) }}
                                handleFilterValue={handleFilterValue}
                            />
                            <br />
                            <Tooltip title="Editar datos del Paciente">
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={() => {
                                        generateExcel();
                                    }}
                                >
                                    EXCEL
                                </Button>
                            </Tooltip>

                        </div>
                        : null
                }

                {showPDF ?
                    <Modal
                        open={showPDF}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                            <IconButton style={{ float: 'right' }} onClick={() => {
                                setShowPDF(false);
                            }}>
                                <CloseIcon />
                            </IconButton>
                            <iframe id="pdfV" width="1000" height="700" >
                            </iframe>
                        </div>
                    </Modal>
                    : null}
            </CardBody>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => {
                    setAlertShowModal(false);
                }}
                toggle={() => setAlertShowModal(false)}
            />

        </Card>
    );
}

export default ReportsPatientsFilter;